
  <mb-dialog-header>
    <h3
      class="mb-dialog-custom__header"
      i18n="@@modals_disneybenefits_beneficios_de_hoteles_disney"
    >
      Beneficios de Hoteles Disney
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <ul>
        <li>
          <div class="mb-col-3">
            <img [src]="imageBenefit(1)" alt="benefits disney" />
          </div>
          <div class="text mb-col-9">
            <strong i18n="@@modals_disneybenefits_traslados_gratis"
              >Traslados Gratis</strong
            >
            <br />
            <span
              i18n="
                @@modals_disneybenefits_trasladate_por_todo_walt_disney_world_sin_costo_en_bus_monorriel_o_ferry"
              >Trasladate por todo Walt Disney World sin costo en bus, monorriel o
              ferry.</span
            >
          </div>
        </li>
        <li>
          <div class="mb-col-3">
            <img [src]="imageBenefit(5)" alt="benefits disney" />
          </div>
          <div class="text mb-col-9">
            <strong i18n="@@magical_express">Magical Express</strong>
            <br />
            <span
              i18n="
                @@modals_disneybenefits_es_el_servicio_de_translado_gratuito_ida_y_vuelta_desde_el_aeropuerto_internacional_de_orlando_a_los_hoteles_disney_resort"
              >Es el servicio de <strong>traslado gratuito ida y vuelta</strong> desde el
              Aeropuerto Internacional de Orlando a los hoteles Disney Resort.</span
            >
          </div>
        </li>
        <li>
          <div class="mb-col-3">
            <img [src]="imageBenefit(6)" alt="benefits disney" />
          </div>
          <div class="text mb-col-9">
            <strong i18n="@@wifi_libre">Wifi libre</strong>
            <br />
            <span
              i18n="
                @@modals_disneybenefits_aprovecha_el_acceso_conveniente_a_internet_en_los_hoteles_y_parques_tematicos_de_walt_disney_world_resort"
              >Aprovecha el acceso conveniente a Internet en los hoteles y Parques
              Temáticos de Walt Disney World Resort.</span
            >
          </div>
        </li>
      </ul>
    </div>
  </mb-dialog-body>
